module.exports = __webpack_public_path__ + "static/img/M-5.3634446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/M-5.png
// module id = WIGp
// module chunks = 0